var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25628 13.0001C5.59799 13.3418 6.15201 13.3418 6.49372 13.0001L11.4937 8.00007L6.49372 3.00006C6.15201 2.65836 5.59799 2.65836 5.25628 3.00006C4.91457 3.34177 4.91457 3.89579 5.25628 4.2375L9.01885 8.00007L5.25628 11.7626C4.91457 12.1043 4.91457 12.6584 5.25628 13.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRightArrow);
export default __webpack_public_path__ + "static/media/whiteRightArrow.232a600586c9233d6dc687462cb1a0d9.svg";
export { ForwardRef as ReactComponent };